import React from "react";
import styled from "styled-components";
import { Digimon } from "../types/common";

interface Props {
  object: {
    className: Digimon;
    probability: number;
  };
}

const ClassAndPercent = ({ object }: Props) => {
  return (
    <Container>
      <Name>{object.className === "쉬몬" ? "쉬라몬" : object.className}</Name>
      <Bar>
        <Value percent={(object.probability * 100).toFixed(2)}>
          {(object.probability * 100).toFixed(2)}%
        </Value>
      </Bar>
    </Container>
  );
};

export default ClassAndPercent;

const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;

  width: 100%;
`;

const Name = styled.div`
  width: 56px;
`;

const Bar = styled.div`
  background-color: #e9afaf;
  flex: 1;

  border-radius: 12px;
`;

const Value = styled.div<{ percent: string }>`
  background-color: #eb6161;
  width: ${({ percent }) => `${percent}%`};
  border-radius: 12px;

  padding: 0 4px;
`;
